export default "__VITE_PUBLIC_ASSET__8a221732__"